import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom'; 
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar'; 
import Footer from '../components/Footer';
import '../App.css'; 

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState(''); 
  const [loading, setLoading] = useState(false);

  const { login, authMessage, setAuthMessage } = useAuth(); 
  const navigate = useNavigate(); 

  useEffect(() => {
     // Optional cleanup logic
  }, [authMessage, setAuthMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    setLocalError('');
    setAuthMessage(null); 
    setLoading(true);

    const success = await login(email, password);

    setLoading(false);
    if (success) {
      navigate('/app'); 
    } else {
      setLocalError('Invalid email or password. Please try again.');
    }
  };

  return (
    /* 1. FIXED: Flex container */
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      
      {/* 2. FIXED: Header fills remaining space */ }
      <header className="App-header" style={{ 
          display: 'flex', 
          flexDirection: 'column',      
          alignItems: 'center',         
          justifyContent: 'flex-start', 
          paddingTop: '60px',           
          flex: 1, // <--- Fills the vertical space
          width: '100%'                 
      }}>
        
        <form className="form-container login-form" onSubmit={handleSubmit} style={{maxWidth: '450px'}}>
          <h2 style={{textAlign: 'center', marginBottom: '20px'}}>Recruiter Login</h2>
          
          {authMessage && (
            <div style={{
                backgroundColor: '#fff3cd', 
                color: '#856404', 
                padding: '10px', 
                borderRadius: '4px', 
                marginBottom: '15px', 
                border: '1px solid #ffeeba',
                fontSize: '0.9rem',
                textAlign: 'center'
            }}>
                {authMessage}
            </div>
          )}

          {localError && <p className="error-message">{localError}</p>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@company.com"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <div style={{textAlign: 'right', marginBottom: '20px'}}>
            <Link to="/forgot-password" style={{fontSize: '0.9rem', color: '#0052cc', textDecoration: 'none'}}>Forgot Password?</Link>
          </div>

          <button 
            type="submit" 
            className="generate-button" 
            disabled={loading}
            style={{marginTop: '20px'}}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div style={{marginTop: '20px', textAlign: 'center', fontSize: '0.9rem', color: '#42526e'}}>
            Don't have an account? <Link to="/signup" style={{color: '#0052cc', fontWeight: '600', textDecoration: 'none'}}>Sign up</Link>
          </div>

        </form>
      </header>

      <Footer />

    </div>
  );
}

export default LoginPage;